import localeAntd from 'ant-design-vue/lib/locale-provider/pt_BR'

const messages = {
	topBar: {
		issuesHistory: 'Histórico de problemas',
		typeToSearch: 'Comece a digitar para pesquisar...',
		actions: 'Ações',
		status: 'Status',
		profileMenu: {
			hello: 'Oi',
			billingPlan: 'Plano de cobrança',
			role: 'Função',
			email: 'Email',
			phone: 'telefone',
			editProfile: 'Editar Perfil',
			logout: 'Sair',
		},
	},
}

export default {
	locale: 'pt-BR',
	localeAntd,
	messages,
}
